import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const faqs = [{
    q: '¿Cómo recibo el material?',
    a: 'Vas a recibir acceso digital inmediato después de la compra. Podés descargar los PDFs y usarlos desde el celular, tablet o computadora.'
  }, {
    q: '¿El material es imprimible?',
    a: 'Sí. Todo el MegaPack está en formato PDF y podés imprimir lo que necesites las veces que quieras.'
  }, {
    q: '¿Sirve para consultorio y apoyo escolar?',
    a: 'Sí. Está pensado para psicopedagogas, docentes de apoyo, acompañantes y profesionales que trabajen lectoescritura.'
  }, {
    q: '¿Incluye recursos para informes y devoluciones?',
    a: 'Sí. El Plan PRO incluye modelos, frases y herramientas para redactar informes, registrar avances y comunicar mejor tu trabajo con familias e institución.'
  }, {
    q: '¿Por qué elegir el Plan PRO?',
    a: 'Porque no solo te llevás actividades. Te llevás un sistema más completo para intervenir, planificar, registrar, decidir y comunicar con más claridad profesional.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí: 7 días de garantía total. Si sentís que no te suma valor, te devolvemos el dinero sin hacer preguntas.'
  }];
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="py-12 px-4 max-w-3xl mx-auto" data-id="element-30">
      <FadeIn data-id="element-31">
        <h2 className="font-display text-3xl md:text-4xl font-bold text-mint text-center mb-8" data-id="element-32">
          PREGUNTAS FRECUENTES
        </h2>
      </FadeIn>

      <div className="space-y-4" data-id="element-33">
        {faqs.map((faq, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-34">
            <div className="bg-surface rounded-xl border border-mint/10 overflow-hidden" data-id="element-35">
              <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full text-left px-6 py-4 flex items-center justify-between font-bold text-mint hover:bg-mint/5 transition-colors" data-id="element-36">
                <span className="pr-4" data-id="element-37">{faq.q}</span>
                <ChevronDown className={`shrink-0 transition-transform duration-300 ${openIdx === idx ? 'rotate-180' : ''}`} size={20} data-id="element-38" />
              </button>
              <AnimatePresence data-id="element-39">
                {openIdx === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-40">
                    <div className="px-6 pb-4 text-white/70" data-id="element-41">{faq.a}</div>
                  </motion.div>}
              </AnimatePresence>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}